// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/modules/providers-list/components/edit-provider/edit-provider.less
// module id = 3781
// module chunks = 0